import { render, staticRenderFns } from "./Developer.vue?vue&type=template&id=405dc2d5&scoped=true&"
import script from "./Developer.vue?vue&type=script&lang=js&"
export * from "./Developer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405dc2d5",
  null
  
)

export default component.exports